<template>
	<div class="footBox">
		开发单位：山东中飞科技有限公司
		<a href="javascript:void(0);">
			鲁ICP备16022226号
		</a>
	</div>
</template>

<script>
	export default {
		name: 'footmain',
		data() {
			return {

			}
		},
		created() {

		},
		mounted() {

		},
		methods: {

		},
		beforeRouteLeave(to, from, next) {
			next();
		},
	}
</script>